// The door from a job's PO card into the archive, pre-scoped to that job.
//
// The label comes from the `document_archive` config (`entry_surface:
// "crm_job_po"`), so renaming the door is a config edit and this component never
// hard-codes the wording. It renders nothing until the archive answers, so a job
// with no documents shows no dead link — and nothing at all when the door is
// disabled in config.
//
// This is one of the archive's two doors. The installer-app door is deferred by
// Jacky's decision ("we will build that when we get to installer app"); its
// `entry_surface` stays recorded in config so that work inherits the decision.
import {useQuery} from "@tanstack/react-query";
import {Link} from "react-router-dom";
import {api,client} from "../lib/api";
import {countItems} from "../lib/archive";

export function JobArchiveLink({jobRef}:{jobRef:string|null|undefined}){
  const browse=useQuery({
    queryKey:["archive","job-door",jobRef],
    enabled:!!jobRef,
    queryFn:()=>api.archive(client,{job:jobRef!}),
  });
  if(!jobRef)return null;
  const data=browse.data;
  if(!data)return null;
  const label=data.entries.find((e)=>e.entry_surface==="crm_job_po")?.entry_label;
  if(!label)return null;
  const n=countItems(data.groups);
  return <Link to={`/archive?job=${encodeURIComponent(jobRef)}`} className="text-sm underline">
    {label}{n>0?` (${n})`:""}
  </Link>;
}
